import UserApi from '@/services/rest/bemob/user';

export class TemporaryPasswordDialogApi {
  userApi: UserApi = new UserApi();

  error: boolean = false;
  data: any = {};

  get() {
    return this.userApi.getTemporaryPassword().then((payload) => {
      this.data = payload;
      return payload;
    });
  };
};

export default new TemporaryPasswordDialogApi();